import { Component, Input, OnInit } from "@angular/core";
import { Condicion } from "../../clases/Condicion";
import { CommandAsync, ICommand } from "@nahuelmorata/ngx-command";
import { obtenerIdGenero, obtenerNombresGenero } from "@shared/enums";
import { ModalService } from "@shared/services";

interface Genero {
    id: string;
    name: string;
}

@Component({
    selector: "app-condicion-su-genero-es",
    templateUrl: "./condicion-su-genero-es.component.html",
    styleUrls: ["./condicion-su-genero-es.component.scss"]
})
export class CondicionSuGeneroEsComponent implements OnInit {
    @Input() public condicion: Condicion;
    public generos: Genero[] = [];

    public borrarOperandoCmd: ICommand = new CommandAsync(() => this.borrar());

    constructor(private modalService: ModalService) {}

    ngOnInit(): void {
        this.generos = obtenerNombresGenero().map(([genero, nombre]) => ({
            id: obtenerIdGenero(genero),
            name: nombre
        }));
    }

    private async borrar() {
        const seguroBorrar = await this.modalService.openModalDecision(
            "Esta seguro que quiere eliminar el operando?", { centered: true }
        );

        if (!seguroBorrar) {
            return;
        }

        this.condicion.borrar();
    }
}
